import { Reveal, SectionHeading } from "@/components/site/Reveal";

const SECTIONS = [
  {
    title: "What we collect",
    text: "When you contact Eucalypt Therapy, we collect the information you provide — such as your name, contact details and the nature of your enquiry — so we can respond and, if you proceed, provide services to you.",
  },
  {
    title: "How your information is used",
    text: "Your information is used only to respond to enquiries, arrange appointments, deliver services and meet professional and legal obligations. It is never sold or used for marketing without your consent.",
  },
  {
    title: "Confidentiality",
    text: "As an Accredited Mental Health Social Worker practice, your information is handled in line with the AASW Code of Ethics and the Privacy Act 1988 (Cth). There are limits to confidentiality where there is risk of harm or a legal requirement to disclose.",
  },
  {
    title: "Access and correction",
    text: "You may request access to, or correction of, your personal information at any time by contacting hello@eucalypttherapy.com.au.",
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
          <SectionHeading eyebrow="Privacy" title="Privacy Policy" lead="How Eucalypt Therapy collects, uses and protects your personal information." />
        </div>
      </section>
      <section className="bg-euca-mist">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 space-y-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div className="rounded-2xl border border-euca-line bg-white p-7 sm:p-8">
                <h2 className="font-serif text-2xl font-medium text-euca-dark">{s.title}</h2>
                <p className="mt-3 text-base leading-relaxed text-mutedsoft">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
